import React from "react";
import { Button, EmptyModal, Textfield } from "../../../../components/core";

export default function RemoteOpenDoorModal({ open = false, onClose }) {
	return (
		<EmptyModal open={open}>
			<div className="w-full px-4">
				<div className="mb-4">
					<img
						src={`${process.env.PUBLIC_URL}/assets/images/error.png`}
						className="mx-auto"
					/>
					<p className="font-bold font-lg text-center mb-4">
						REMOTE OPEN DOOR OTP
					</p>
					<p className="mb-2 text-center">
						An OTP was sent to user mobile 12312332. Please enter OTP to
						remotely open door
					</p>
					<Textfield
						placeholder={"XXXX-XXXX"}
						classNameParent={"w-1/2 mx-auto"}
					/>
					<hr className="my-4"></hr>
					<div className="grid grid-cols-2 gap-4">
						<Button
							className={"p-2 text-white bg-secondary-darkGray"}
							value={"GO BACK"}
							onClick={onClose}
						/>
						<Button
							className={"p-2 text-white bg-secondary-darkGray"}
							value={"OPEN DOOR"}
							onClick={onClose}
						/>
					</div>
				</div>
			</div>
		</EmptyModal>
	);
}
